<div class="atn-ds-table-search-input">
  <atn-ds-search
    [value]="searchValueSg()"
    [config]="searchConfigSg()"
    (valueChange)="searchInputChangeHandler($event)"
  />
</div>
